<template>
  <v-select
    ref="select"
    v-model="localIndex"
    item-text="text"
    item-value="index"
    :items="normalizedOptions"
    :label="label"
    :required="required"
    @blur="blur"
    autocomplete
  />
</template>

<script>
export default {
  props: {
    value: Object,
    options: Array,
    size: {
      type: String,
      default: 'md'
    },
    idField: {
      type: String,
      default: '_self'
    },
    nameField: {
      type: String,
      default: 'name'
    },
    label: String,
    required: Boolean
  },
  data () {
    return {
      localIndex: this.value && this.options.findIndex(item => item[this.idField] === this.value[this.idField])
    }
  },
  watch: {
    localIndex () {
      let value = this.options[this.localIndex]
      this.$emit('input', value)
    },
    options () {
      this.localIndex = this.value && this.options.findIndex(item => item[this.idField] === this.value[this.idField])
    }
  },
  computed: {
    normalizedOptions () {
      return this.options.map((item, index) => {
        return {
          index,
          text: item[this.nameField]
        }
      })
    }
  },
  methods: {
    focus () {
      this.$refs.select.focus()
    },
    blur () {
      this.$emit('blur')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ObjectSelect.vue?47873b1c